import React from 'react';

const DateSeparator: React.FC<{ label: string }> = ({ label }) => (
  <div className="flex justify-center my-1.5">
    <div className="px-3 py-1 rounded-lg bg-white shadow-sm text-[11.5px] font-semibold text-gray-500">
      {label}
    </div>
  </div>
);

export default DateSeparator;
